var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('el-card',{staticClass:"box-card",attrs:{"shadow":"never"}},[_vm._v(" 登录日志 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }